import {useInfiniteQuery} from 'react-query';
import api from 'utils/api';
import domainKeys from './queryKeys';

export async function fetchDomains(query) {
	let q = {
		fields: ['id', 'name', 'domain', 'subdomain'],
		filter: {
			status: ['active', 'maintenance'],
		},
		orderby: 'name',
		limit: 100,
	};

	if (typeof query === 'object') {
		// extend the filter
		q.filter = {...q.filter, ...query};
	} else if (typeof query === 'string') {
		// replace the whole thing
		q = query;
	}
	const resp = await api('get', '/api/query/childDomains', q);

	// Display the domain if the name is missing.
	resp.items.forEach(item => {
		if (!item.name) {
			item.name = item.subdomain;
		}
	});
	return resp;
}

export function useFetchDomains(query) {
	async function queryFn({pageParam}) {
		if (pageParam === false) {
			return {};
		}
		return fetchDomains(pageParam || query);
	}

	const {data = {}, ...queryProps} = useInfiniteQuery(
		domainKeys.domainsList(query),
		queryFn,
		{
			getNextPageParam(lastPage) {
				return lastPage.next || false;
			},
			staleTime: 10 * 1000, // Ten seconds
		}
	);

	const items =
		data.pages?.filter(page => page.items).flatMap(page => page.items) ||
		[];

	return {
		items,
		...queryProps,
	};
}

export default useFetchDomains;
